import { Action } from '../actions/amenities';

const defaultState = {
  isFetching: false,
  byId: {},
  error: undefined,
};

export default function amenitiesReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Amenities.AmenitiesPending:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      };

    case Action.Amenities.AmenitiesCompleted:
      return {
        ...state,
        isFetching: false,
        byId: body.amenities.reduce((all, one) => ({
          ...all,
          [one.id]: one,
        }), state.byId),
      };

    case Action.Amenities.AmenitiesFailed:
      return {
        ...state,
        isFetching: false,
        error: body,
      };

    default:
      return state;
  }
}
